/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    isFetchingResult: false,
    isValidResult: false,
    isFailedFetchingResult: false,
    result: {},
  },
  reducers: {
    getResult: (state) => {
      state.isFetchingResult = true;
      state.isValidResult = false;
      state.isFailedFetchingResult = false;
      state.result = [];
    },
    getResultS: (state, action) => {
      state.isFetchingResult = false;
      state.isValidResult = true;
      state.isFailedFetchingResult = false;
      state.result = action.payload;
    },
    getResultF: (state) => {
      state.isFetchingResult = false;
      state.isValidResult = false;
      state.isFailedFetchingResult = true;
      state.result = [];
    },
    invalidateResult: (state) => {
      state.isFetchingResult = false;
      state.isValidResult = false;
      state.isFailedFetchingResult = false;
      state.result = [];
    },
  },
});

export const {
  getResult,
  getResultS,
  getResultF,
  invalidateResult,
} = searchSlice.actions;

export default searchSlice.reducer;
